export default __webpack_public_path__ + "static/media/InsurproLogo.58e0e964.svg";